import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Aboutheader from '../components/About/Aboutheader'
import InsideValuation from '../components/About/InsideValuation'
import WorkingTogetherSplit from '../components/About/WorkingTogetherSplit'
import Contactfooter from '../components/Contactfooter'

const Aboutpage = () => {
    return (
        <div>
        <Navbar/>
        <Aboutheader/>
        <InsideValuation/>
        <WorkingTogetherSplit/>
         <Contactfooter/>


        <Footer/>

        </div>
    )
}

export default Aboutpage